var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarIconAwesomeFileSignature(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.636,
    height: 22.788,
    viewBox: "0 0 25.636 22.788",
    fill: "#cae7f1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-file-signature",
    "data-name": "Icon awesome-file-signature",
    d: "M9.71,18.877a.493.493,0,0,0-.453-.29.485.485,0,0,0-.446.275l-.341.683a.712.712,0,0,1-1.312-.093l-.749-2.246-.472,1.419a1.921,1.921,0,0,1-1.825,1.314H3.561a.712.712,0,1,1,0-1.424h.551a.5.5,0,0,0,.474-.341l.81-2.432a1.069,1.069,0,0,1,2.027,0L8.04,17.6a2,2,0,0,1,2.937.63.505.505,0,0,0,.417.279V14.849l5.7-5.656V7.121H11.038A1.071,1.071,0,0,1,9.97,6.053V0h-8.9A1.066,1.066,0,0,0,0,1.068V21.719a1.066,1.066,0,0,0,1.068,1.068H16.022a1.066,1.066,0,0,0,1.068-1.068v-1.78l-5.7,0A1.911,1.911,0,0,1,9.71,18.877ZM17.091,5.425a1.065,1.065,0,0,0-.312-.752L12.422.312A1.067,1.067,0,0,0,11.665,0h-.271V5.7h5.7ZM12.818,15.442v3.073h3.071l7.2-7.245L20.063,8.249l-7.245,7.193ZM25.3,7.447,23.886,6.029a1.134,1.134,0,0,0-1.6,0L21.07,7.242l3.021,3.021L25.3,9.05A1.133,1.133,0,0,0,25.3,7.447Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarIconAwesomeFileSignature);
export default __webpack_public_path__ + "static/media/Sidebar-Icon-awesome-file-signature.06210f4c3157e8bc3942fb48d975e1f1.svg";
export { ForwardRef as ReactComponent };